import PdfViewer from "./PdfViewer";

export default class Collapse {

    static initializeEvents() {
        document.addEventListener('click', function (event) {
            const button = event.target.closest('.collapse-button');
            if (button) {
                event.preventDefault();
                let element = document.getElementById(button.id);
                if (!element.hasAttribute('open')) {
                    element.setAttribute('aria-expanded', 'true');
                    element.setAttribute('open', '');
                    element.parentElement.parentElement.setAttribute('open', '');
                    element.parentElement.nextElementSibling.removeAttribute('hidden');

                    const viewer = element.parentElement.nextElementSibling.querySelector('[data-pdf-viewer-url]:not([data-loaded])');
                    if (viewer && typeof PdfViewer !== 'undefined') {
                        PdfViewer.renderViewer(viewer);
                    }

                } else {
                    element.setAttribute('aria-expanded', 'false');
                    element.removeAttribute('open');
                    element.parentElement.parentElement.removeAttribute('open');
                    element.parentElement.nextElementSibling.setAttribute('hidden', '');
                }
            }
        });

        // Pour l'impression, les composants "collapse" s'ouvrent tous
        window.addEventListener('beforeprint', () => {
            Array
                .from(document.querySelectorAll('.collapse:not([open])'))
                .forEach(collapse => {
                    collapse.setAttribute('open', '');
                    collapse.getElementsByClassName('collapse-content')[0].removeAttribute('hidden');

                });
        });

        // Après l'impression, les composants "collapse" se ferment tous
        window.addEventListener('afterprint', () => {
            Array
                .from(document.querySelectorAll('.collapse[open]'))
                .forEach(collapse =>{
                    collapse.removeAttribute('open')
                    collapse.getElementsByClassName('collapse-content')[0].setAttribute('hidden', '');
                });
        });
    }

}